import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";
const client = new ApiClient(client_core)

const endpoints = {
    impersonate: '/impersonate/user/impersonate/',
    list: '/impersonate/user/',
}

export default {
    async fetchUsersList(filters, pagination, sorting) {
        let result = await client.get(endpoints.list, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.asc ? `-${sorting.column}` : sorting.column ?? ''
        })
        return {
            results: result.results,
            pagination: {
                num_pages: result.pagination.num_pages,
                page_size: result.pagination.page_size,
                page: result.pagination.page_number,
                total: result.pagination.total,
            }
        }
    },
    async impersonate(id) {
        return await client.post(endpoints.impersonate, {user: id})
    }
}
